/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".host_0204bcfb{display:inline-block}.hostOverflow_0204bcfb{display:inline}\n"}]);
export const host = "host_0204bcfb";
export const hostOverflow = "hostOverflow_0204bcfb";